import { stepTravellerMedicalBenefitsTugoLookup as expenseLookup } from './claimCodeMapper';
import { MEDICAL_EXPENSE_TYPES } from '../Tugo.TravellerMedicalBenefits/constants';

function mapToParentSection() {
  return {};
}

function mapToQuestionnaire() {
  return [];
}

const getLookupKeyToConfig = (data, expensesSelected) => ({
  // Doctor's Visit - Telemedicine (telephone or video call)
  telemedicine: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.DOCTORS_VISIT],
    condition: () => expensesSelected.includes(MEDICAL_EXPENSE_TYPES.DOCTORS_VISIT) && data.doctorVisitTelemedicine === 'true',
    getDescription: () => 'Telemedicine Benefit',
    benefitTitle: "Doctor's Visit",
    documentClaimCodeLookupKey: 'physicianParent',
  },
  // Doctor's Visit - First Visit (Outpatient Physician Fees)
  outpatientPhysicianFees: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.DOCTORS_VISIT],
    condition: () => expensesSelected.includes(MEDICAL_EXPENSE_TYPES.DOCTORS_VISIT) && data.doctorVisitFirstVisit === 'true',
    getDescription: () => "Doctor's Visit",
    benefitTitle: "Doctor's Visit",
    documentClaimCodeLookupKey: 'physicianParent',
    getDocumentDescription: () => 'Physician Fees',
  },
  // Doctor's Visit - Follow-up Visit
  followUpVisit: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.DOCTORS_VISIT],
    condition: () => expensesSelected.includes(MEDICAL_EXPENSE_TYPES.DOCTORS_VISIT) && data.doctorVisitFollowUp === 'true',
    getDescription: () => 'Follow-up visits',
    benefitTitle: "Doctor's Visit",
    documentClaimCodeLookupKey: 'physicianParent',
  },
  // Doctor's Visit - Fracture Treatment (also used by standalone Fracture Treatment checkbox)
  fractureTreatment: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.DOCTORS_VISIT, MEDICAL_EXPENSE_TYPES.FRACTURE_TREATMENT],
    condition: () => (expensesSelected.includes(MEDICAL_EXPENSE_TYPES.DOCTORS_VISIT) && data.doctorVisitFollowUpFracture === 'true') || expensesSelected.includes(MEDICAL_EXPENSE_TYPES.FRACTURE_TREATMENT),
    getDescription: () => 'Fracture Treatment',
    benefitTitle: "Doctor's Visit",
    documentClaimCodeLookupKey: 'physicianParent',
  },
  // Diagnostic Tests
  diagnosticTests: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.DIAGNOSTIC_TESTS],
    condition: () => expensesSelected.includes(MEDICAL_EXPENSE_TYPES.DIAGNOSTIC_TESTS),
    getDescription: () => 'Diagnostic Tests',
    benefitTitle: 'Diagnostic Tests',
  },
  // Prescription Drugs
  prescriptionDrugs: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.PRESCRIPTION_DRUGS],
    condition: () => expensesSelected.includes(MEDICAL_EXPENSE_TYPES.PRESCRIPTION_DRUGS) && data.prescriptionDrugsLost !== 'false',
    getDescription: () => 'Prescription Drugs',
    benefitTitle: 'Prescription Drugs',
  },
  prescriptionDrugsLost: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.PRESCRIPTION_DRUGS],
    condition: () => expensesSelected.includes(MEDICAL_EXPENSE_TYPES.PRESCRIPTION_DRUGS) && data.prescriptionDrugsLost === 'false',
    getDescription: () => 'Prescription Drugs',
    benefitTitle: 'Prescription Drugs',
  },
  // Ambulance Services - Ground
  groundAmbulance: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.AMBULANCE_SERVICES],
    condition: () => expensesSelected.includes(MEDICAL_EXPENSE_TYPES.AMBULANCE_SERVICES) && data.ambulanceGroundService === 'true',
    getDescription: () => 'Ground Ambulance',
    benefitTitle: 'Ambulance Services',
    documentClaimCodeLookupKey: 'ambulanceParent',
    getDocumentDescription: () => 'Ambulance services',
  },
  // Ambulance Services - Air
  airAmbulance: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.AMBULANCE_SERVICES],
    condition: () => expensesSelected.includes(MEDICAL_EXPENSE_TYPES.AMBULANCE_SERVICES) && data.ambulanceGroundService === 'false' && data.ambulanceAirService === 'true',
    getDescription: () => 'Air Ambulance',
    benefitTitle: 'Ambulance Services',
    documentClaimCodeLookupKey: 'ambulanceParent',
    getDocumentDescription: () => 'Ambulance services',
  },
  // Ambulance Services - Other
  otherAmbulance: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.AMBULANCE_SERVICES],
    condition: () => expensesSelected.includes(MEDICAL_EXPENSE_TYPES.AMBULANCE_SERVICES) && data.ambulanceGroundService === 'false' && data.ambulanceAirService === 'false',
    getDescription: () => 'Other Types of Ambulances',
    benefitTitle: 'Ambulance Services',
    documentClaimCodeLookupKey: 'ambulanceParent',
    getDocumentDescription: () => 'Ambulance services',
  },
  // Hospitalization
  hospitalFees: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.HOSPITALIZATION],
    condition: () => expensesSelected.includes(MEDICAL_EXPENSE_TYPES.HOSPITALIZATION) && data.hospitalizationHospitalFees === true,
    getDescription: () => 'Hospital Fees',
    benefitTitle: 'Hospitalization',
  },
  inpatientPhysicianFees: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.HOSPITALIZATION],
    condition: () => expensesSelected.includes(MEDICAL_EXPENSE_TYPES.HOSPITALIZATION) && data.hospitalizationInpatientPhysicianFees === true,
    getDescription: () => 'Physician Fees while hospitalized',
    benefitTitle: 'Hospitalization',
    documentClaimCodeLookupKey: 'physicianParent',
    getDocumentDescription: () => 'Physician Fees',
  },
  xrayLabsDiagnostics: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.HOSPITALIZATION],
    condition: () => expensesSelected.includes(MEDICAL_EXPENSE_TYPES.HOSPITALIZATION) && data.hospitalizationXrayLabsDiagnostics === true,
    getDescription: () => 'X-Ray, Labs, or other diagnostics while hospitalized',
    benefitTitle: 'Hospitalization',
    documentClaimCodeLookupKey: 'hospitalFees',
  },
  emergencyAirTransportation: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.HOSPITALIZATION],
    condition: () => expensesSelected.includes(MEDICAL_EXPENSE_TYPES.HOSPITALIZATION) && data.hospitalizationEmergencyAirTransportation === true,
    getDescription: () => 'Emergency Air Transportation',
    benefitTitle: 'Hospitalization',
  },
  airfareReturnHome: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.HOSPITALIZATION],
    condition: () => expensesSelected.includes(MEDICAL_EXPENSE_TYPES.HOSPITALIZATION) && data.hospitalizationAirfareReturnHome === true,
    getDescription: () => 'Airfare to Return Home For Treatment',
    benefitTitle: 'Hospitalization',
  },
  familyTransportation: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.HOSPITALIZATION],
    condition: () => expensesSelected.includes(MEDICAL_EXPENSE_TYPES.HOSPITALIZATION) && data.hospitalizationFamilyTransportation === true,
    getDescription: () => 'Family Transportation',
    benefitTitle: 'Hospitalization',
  },
  familyTransportationMealsAccommodation: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.HOSPITALIZATION],
    condition: () => expensesSelected.includes(MEDICAL_EXPENSE_TYPES.HOSPITALIZATION) && data.hospitalizationFamilyTransportationMealsAccommodation === true,
    getDescription: () => 'Family Transportation Meals and Accommodation',
    benefitTitle: 'Hospitalization',
  },
  medicalAttendant: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.HOSPITALIZATION],
    condition: () => expensesSelected.includes(MEDICAL_EXPENSE_TYPES.HOSPITALIZATION) && data.hospitalizationMedicalAttendant === true,
    getDescription: () => 'Medical Attendant',
    benefitTitle: 'Hospitalization',
  },
  returnOfTravellingCompanion: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.HOSPITALIZATION],
    condition: () => expensesSelected.includes(MEDICAL_EXPENSE_TYPES.HOSPITALIZATION) && data.hospitalizationReturnOfTravellingCompanion === true,
    getDescription: () => 'Return of Travelling Companion',
    benefitTitle: 'Hospitalization',
  },
  returnOfDependentChildren: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.HOSPITALIZATION],
    condition: () => expensesSelected.includes(MEDICAL_EXPENSE_TYPES.HOSPITALIZATION) && data.hospitalizationReturnOfDependentChildren === true,
    getDescription: () => 'Return of Dependent Children',
    benefitTitle: 'Hospitalization',
  },
  airlineSeatUpgrade: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.HOSPITALIZATION],
    condition: () => expensesSelected.includes(MEDICAL_EXPENSE_TYPES.HOSPITALIZATION) && data.hospitalizationAirlineSeatUpgrade === true,
    getDescription: () => 'Airline Seat Upgrade when medically required by the attending physician',
    benefitTitle: 'Hospitalization',
  },
  returnOfPets: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.HOSPITALIZATION],
    condition: () => expensesSelected.includes(MEDICAL_EXPENSE_TYPES.HOSPITALIZATION) && data.hospitalizationReturnOfPets === true,
    getDescription: () => 'Return of Pets',
    benefitTitle: 'Hospitalization',
  },

  medicalFollowUpInCanadaSemiPrivate: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.HOSPITALIZATION],
    condition: () => expensesSelected.includes(MEDICAL_EXPENSE_TYPES.HOSPITALIZATION) && data.hospitalizationMedicalFollowUpInCanada === true && data.hospitalizationMedicalFollowUpInCanadaSemiPrivate === true,
    getDescription: () => 'Follow-Up in Canada - Semi Private room',
    benefitTitle: 'Hospitalization',
  },
  medicalFollowUpInCanadaAmbulance: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.HOSPITALIZATION],
    condition: () => expensesSelected.includes(MEDICAL_EXPENSE_TYPES.HOSPITALIZATION) && data.hospitalizationMedicalFollowUpInCanada === true && data.hospitalizationMedicalFollowUpInCanadaAmbulance === true,
    getDescription: () => 'Follow-Up in Canada - Ambulance or Taxi',
    benefitTitle: 'Hospitalization',
  },
  medicalFollowUpInCanadaHomeCare: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.HOSPITALIZATION],
    condition: () => expensesSelected.includes(MEDICAL_EXPENSE_TYPES.HOSPITALIZATION) && data.hospitalizationMedicalFollowUpInCanada === true && data.hospitalizationMedicalFollowUpInCanadaHomeCare === true,
    getDescription: () => 'Follow-Up in Canada - Home Care Nursing',
    benefitTitle: 'Hospitalization',
  },
  medicalFollowUpInCanadaEssentialMedicalApp: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.HOSPITALIZATION],
    condition: () => expensesSelected.includes(MEDICAL_EXPENSE_TYPES.HOSPITALIZATION) && data.hospitalizationMedicalFollowUpInCanada === true && data.hospitalizationMedicalFollowUpInCanadaEssentialMedicalApp === true,
    getDescription: () => 'Follow-Up in Canada - Essential Medical Appliances',
    benefitTitle: 'Hospitalization',
  },
  returnToYourDestination: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.HOSPITALIZATION],
    condition: () => expensesSelected.includes(MEDICAL_EXPENSE_TYPES.HOSPITALIZATION) && data.hospitalizationReturnToYourDestination === true,
    getDescription: () => 'Return to Your Destination',
    benefitTitle: 'Hospitalization',
  },
  hospitalAllowance: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.HOSPITALIZATION],
    condition: () => expensesSelected.includes(MEDICAL_EXPENSE_TYPES.HOSPITALIZATION) && data.hospitalizationHospitalAllowance === true,
    getDescription: () => 'Hospital Allowance',
    benefitTitle: 'Hospitalization',
  },
  outOfPocketExpenses: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.HOSPITALIZATION],
    condition: () => expensesSelected.includes(MEDICAL_EXPENSE_TYPES.HOSPITALIZATION) && data.hospitalizationOutOfPocketExpenses === true,
    getDescription: () => 'Out-Of-Pocket Expenses',
    benefitTitle: 'Hospitalization',
  },
  childcare: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.HOSPITALIZATION],
    condition: () => expensesSelected.includes(MEDICAL_EXPENSE_TYPES.HOSPITALIZATION) && data.hospitalizationChildcare === true,
    getDescription: () => 'Childcare',
    benefitTitle: 'Hospitalization',
  },
  hospitalizationReturnOfVehicle: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.HOSPITALIZATION],
    condition: () => expensesSelected.includes(MEDICAL_EXPENSE_TYPES.HOSPITALIZATION) && data.hospitalizationReturnOfVehicle === true,
    getDescription: () => 'Return of Vehicle',
    benefitTitle: 'Hospitalization',
  },
  otherHospitalization: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.HOSPITALIZATION],
    condition: () => expensesSelected.includes(MEDICAL_EXPENSE_TYPES.HOSPITALIZATION) && data.hospitalizationOtherRelated === true,
    getDescription: () => 'Other expenses related to hospitalization',
    benefitTitle: 'Hospitalization',
  },
  // Essential Medical Equipment
  essentialMedicalEquipment: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.ESSENTIAL_MEDICAL_APPLIANCES],
    condition: () => expensesSelected.includes(MEDICAL_EXPENSE_TYPES.ESSENTIAL_MEDICAL_APPLIANCES),
    getDescription: () => 'Essential Medical Equipment',
    benefitTitle: 'Essential Medical Equipment',
  },
  // Private Duty Nursing
  privateDutyNursing: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.PRIVATE_DUTY_NURSING],
    condition: () => expensesSelected.includes(MEDICAL_EXPENSE_TYPES.PRIVATE_DUTY_NURSING),
    getDescription: () => 'Private Duty Nursing',
    benefitTitle: 'Private Duty Nursing',
  },
  // Unexpected Birth of a Child
  unexpectedBirthOfChild: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.UNEXPECTED_BIRTH_OF_CHILD],
    condition: () => expensesSelected.includes(MEDICAL_EXPENSE_TYPES.UNEXPECTED_BIRTH_OF_CHILD),
    getDescription: () => 'Unexpected Birth of a Child',
    benefitTitle: 'Unexpected Birth of a Child',
    documentClaimCodeLookupKey: 'unexpectedBirthOfChild',
    getDocumentDescription: () => 'Unexpected Birth of a Child',
  },
  // Dental Services
  dentalAccident: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.DENTAL_SERVICES],
    condition: () => expensesSelected.includes(MEDICAL_EXPENSE_TYPES.DENTAL_SERVICES) && data.dentalServicesDentalAccident === true,
    getDescription: () => 'Dental Accident (result of a blow to the face)',
    benefitTitle: 'Dental Services',
  },
  dentalPainOther: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.DENTAL_SERVICES],
    condition: () => expensesSelected.includes(MEDICAL_EXPENSE_TYPES.DENTAL_SERVICES) && data.dentalServicesDentalPainOther === true,
    getDescription: () => 'Dental pain other than accident',
    benefitTitle: 'Dental Services',
  },
  // Expenses Related to Death
  deathReturnOfRemains: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.EXPENSES_RELATED_TO_DEATH_REPATRIATION],
    condition: () =>
      expensesSelected.includes(MEDICAL_EXPENSE_TYPES.EXPENSES_RELATED_TO_DEATH_REPATRIATION) &&
      data.expensesRelatedToDeathReturnRemains === true,
    getDescription: () => 'Return of remains to home country',
    benefitTitle: 'Expenses Related to Death',
  },
  deathBurialCremation: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.EXPENSES_RELATED_TO_DEATH_REPATRIATION],
    condition: () =>
      expensesSelected.includes(MEDICAL_EXPENSE_TYPES.EXPENSES_RELATED_TO_DEATH_REPATRIATION) &&
      data.expensesRelatedToDeathBurialCremation === true,
    getDescription: () => 'Burial or Cremation at Place of Death',
    benefitTitle: 'Expenses Related to Death',
  },
  deathFamilyTransportation: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.EXPENSES_RELATED_TO_DEATH_REPATRIATION],
    condition: () =>
      expensesSelected.includes(MEDICAL_EXPENSE_TYPES.EXPENSES_RELATED_TO_DEATH_REPATRIATION) &&
      data.expensesRelatedToDeathFamilyTransportation === true,
    getDescription: () => 'Transportation of Family Member to Identify Remains when required',
    benefitTitle: 'Expenses Related to Death',
  },
  // Professional Services (in whatExpensesAreYouClaimingFor)
  physiotherapist: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.PROFESSIONAL_SERVICES],
    condition: () => expensesSelected.includes(MEDICAL_EXPENSE_TYPES.PROFESSIONAL_SERVICES) && data.professionalServicesPhysiotherapist === true,
    getDescription: () => 'Physiotherapist',
    benefitTitle: 'Professional Services',
  },
  chiropractor: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.PROFESSIONAL_SERVICES],
    condition: () => expensesSelected.includes(MEDICAL_EXPENSE_TYPES.PROFESSIONAL_SERVICES) && data.professionalServicesChiropractor === true,
    getDescription: () => 'Chiropractor',
    benefitTitle: 'Professional Services',
  },
  chiropodist: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.PROFESSIONAL_SERVICES],
    condition: () => expensesSelected.includes(MEDICAL_EXPENSE_TYPES.PROFESSIONAL_SERVICES) && data.professionalServicesChiropodist === true,
    getDescription: () => 'Chiropodist',
    benefitTitle: 'Professional Services',
  },
  osteopath: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.PROFESSIONAL_SERVICES],
    condition: () => expensesSelected.includes(MEDICAL_EXPENSE_TYPES.PROFESSIONAL_SERVICES) && data.professionalServicesOsteopath === true,
    getDescription: () => 'Osteopath',
    benefitTitle: 'Professional Services',
  },
  podiatrist: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.PROFESSIONAL_SERVICES],
    condition: () => expensesSelected.includes(MEDICAL_EXPENSE_TYPES.PROFESSIONAL_SERVICES) && data.professionalServicesPodiatrist === true,
    getDescription: () => 'Podiatrist',
    benefitTitle: 'Professional Services',
  },
  acupuncturist: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.PROFESSIONAL_SERVICES],
    condition: () => expensesSelected.includes(MEDICAL_EXPENSE_TYPES.PROFESSIONAL_SERVICES) && data.professionalServicesAcupuncturist === true,
    getDescription: () => 'Acupuncturist',
    benefitTitle: 'Professional Services',
  },
  optometrist: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.PROFESSIONAL_SERVICES],
    condition: () => expensesSelected.includes(MEDICAL_EXPENSE_TYPES.PROFESSIONAL_SERVICES) && data.professionalServicesOptometrist === true,
    getDescription: () => 'Optometrist',
    benefitTitle: 'Professional Services',
  },
  // Remote Evacuation
  remoteEvacuation: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.REMOTE_EVACUATION],
    condition: () => expensesSelected.includes(MEDICAL_EXPENSE_TYPES.REMOTE_EVACUATION),
    getDescription: () => 'Remote Evacuation',
    benefitTitle: 'Remote Evacuation',
  },
  // Vision Care and Hearing Aids
  visionCareHearingAids: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.VISION_CARE_HEARING_AIDS],
    condition: () => expensesSelected.includes(MEDICAL_EXPENSE_TYPES.VISION_CARE_HEARING_AIDS),
    getDescription: () => 'Replacement of Prescription Glasses, Sunglasses, Contact Lenses or Hearing Aid',
    benefitTitle: 'Vision Care and Hearing Aids',
  },
  // Air Travel Delay
  airTravelDelayHotelOrRestaurant: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.AIR_TRAVEL_DELAY],
    condition: () => expensesSelected.includes(MEDICAL_EXPENSE_TYPES.AIR_TRAVEL_DELAY) && data.airTravelDelayHotelOrRestaurant === true,
    getDescription: () => 'Hotel, motel or restaurant expenses if your flight has been delayed for more than 4 hours',
    benefitTitle: 'Air Travel Delay',
  },
  airTravelDelayAdditionalTransport: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.AIR_TRAVEL_DELAY],
    condition: () => expensesSelected.includes(MEDICAL_EXPENSE_TYPES.AIR_TRAVEL_DELAY) && data.airTravelDelayAdditionalTransport === true,
    getDescription: () => 'Additional transport expenses if your flight has been delayed for more than 4 hours',
    benefitTitle: 'Air Travel Delay',
  },
  airTravelDelayEntertainment: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.AIR_TRAVEL_DELAY],
    condition: () => expensesSelected.includes(MEDICAL_EXPENSE_TYPES.AIR_TRAVEL_DELAY) && data.airTravelDelayEntertainment === true,
    getDescription: () => 'Entertainment expenses if your flight has been delayed for more than 4 hours',
    benefitTitle: 'Air Travel Delay',
  },
  airTravelDelayEssentialClothing: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.AIR_TRAVEL_DELAY],
    condition: () => expensesSelected.includes(MEDICAL_EXPENSE_TYPES.AIR_TRAVEL_DELAY) && data.airTravelDelayEssentialClothing === true,
    getDescription: () => 'Essential Clothing and Personal Care Items if your baggage has been lost or delayed by the airline for more than 6 hours.',
    benefitTitle: 'Air Travel Delay',
  },
  // Other (unrelated to any benefit listed above)
  otherUnrelatedBenefit: {
    expenseTypes: [MEDICAL_EXPENSE_TYPES.OTHER_UNRELATED_BENEFIT],
    condition: () => expensesSelected.includes(MEDICAL_EXPENSE_TYPES.OTHER_UNRELATED_BENEFIT),
    getDescription: () => MEDICAL_EXPENSE_TYPES.OTHER_UNRELATED_BENEFIT,
    benefitTitle: 'Other',
  },
});

// Generic function to map any type of expense
function mapExpensesByType(data, itemsKey, expenseLookupKey, condition = true, benefitTitle = null) {
  const itemsList = data[itemsKey];
  const itemsLength = itemsList && (itemsList.size !== undefined ? itemsList.size : itemsList.length);
  if (!condition || !itemsList || itemsLength < 1) {
    return [];
  }

  if (!Object.prototype.hasOwnProperty.call(expenseLookup, expenseLookupKey)) {
    return [];
  }

  const lookup = expenseLookup[expenseLookupKey];
  const claimCode = (lookup && lookup.claimCode)
    || (lookup && lookup.associatedClaimCodes && lookup.associatedClaimCodes.length > 0
      ? lookup.associatedClaimCodes[0]
      : null);

  if (!claimCode) {
    return [];
  }

  const expenses = [];

  data[itemsKey].forEach((item) => {
    const expense = mapExpenseItem(item, claimCode);
    if (!!expense) {
      expense.benefitTitle = benefitTitle;
      expenses.push(expense);
    }
  });

  return expenses;
}

function mapToExpenses(data) {
  const expensesSelected = !!data.whatExpensesAreYouClaimingFor && typeof data.whatExpensesAreYouClaimingFor.toJS === 'function'
    ? data.whatExpensesAreYouClaimingFor.toJS()
    : data.whatExpensesAreYouClaimingFor || [];

  const lookupKeyToConfig = getLookupKeyToConfig(data, expensesSelected);

  const expenseConfigs = [
    // Doctor's Visit expenses (items, lookup, condition, benefitTitle)
    { items: 'infoTelemedicineItems', lookup: 'telemedicine', title: 'Doctor\'s Visit' },
    { items: 'infoOutpatientPhysicianFeesItems', lookup: 'outpatientPhysicianFees', title: 'Doctor\'s Visit' },
    { items: 'infoFollowUpVisitItems', lookup: 'followUpVisit', title: 'Doctor\'s Visit' },
    { items: 'infoFollowUpFractureItems', lookup: 'fractureTreatment', title: 'Doctor\'s Visit' },
    // Diagnostic Tests
    { items: 'infoDiagnosticTestsItems', lookup: 'diagnosticTests', title: 'Diagnostic Tests' },
    // Prescription Drugs
    { items: 'infoPrescriptionDrugsItems', lookup: data.prescriptionDrugsLost === 'false' ? 'prescriptionDrugsLost' : 'prescriptionDrugs', title: 'Prescription Drugs' },
    // Ambulance Services
    { items: 'infoGroundAmbulanceItems', lookup: 'groundAmbulance', title: 'Ambulance Services' },
    { items: 'infoAirAmbulanceItems', lookup: 'airAmbulance', title: 'Ambulance Services' },
    { items: 'infoOtherAmbulanceItems', lookup: 'otherAmbulance', title: 'Ambulance Services' },
    // Hospitalization
    { items: 'infoHospitalFeesItems', lookup: 'hospitalFees', title: 'Hospitalization' },
    { items: 'infoInpatientPhysicianFeesItems', lookup: 'inpatientPhysicianFees', title: 'Hospitalization' },
    { items: 'infoXrayLabsDiagnosticsItems', lookup: 'xrayLabsDiagnostics', title: 'Hospitalization' },
    { items: 'infoEmergencyAirTransportationItems', lookup: 'emergencyAirTransportation', title: 'Hospitalization' },
    { items: 'infoAirfareReturnHomeItems', lookup: 'airfareReturnHome', title: 'Hospitalization' },
    { items: 'infoFamilyTransportationItems', lookup: 'familyTransportation', title: 'Hospitalization' },
    { items: 'infoFamilyTransportationMealsAccommodationItems', lookup: 'familyTransportationMealsAccommodation', title: 'Hospitalization' },
    { items: 'infoMedicalAttendantItems', lookup: 'medicalAttendant', title: 'Hospitalization' },
    { items: 'infoReturnOfTravellingCompanionItems', lookup: 'returnOfTravellingCompanion', title: 'Hospitalization' },
    { items: 'infoReturnOfDependentChildrenItems', lookup: 'returnOfDependentChildren', title: 'Hospitalization' },
    { items: 'infoAirlineSeatUpgradeItems', lookup: 'airlineSeatUpgrade', title: 'Hospitalization' },
    { items: 'infoReturnOfPetsItems', lookup: 'returnOfPets', title: 'Hospitalization' },
    { items: 'infoHospitalAllowanceItems', lookup: 'hospitalAllowance', title: 'Hospitalization' },
    { items: 'infoOutOfPocketExpensesItems', lookup: 'outOfPocketExpenses', title: 'Hospitalization' },
    { items: 'infoChildcareItems', lookup: 'childcare', title: 'Hospitalization' },
    { items: 'infoHospitalizationReturnOfVehicleItems', lookup: 'hospitalizationReturnOfVehicle', title: 'Hospitalization' },

    { items: 'infoMedicalFollowUpInCanadaSemiPrivateItems', lookup: 'medicalFollowUpInCanadaSemiPrivate', title: 'Hospitalization' },
    { items: 'infoMedicalFollowUpInCanadaAmbulanceItems', lookup: 'medicalFollowUpInCanadaAmbulance', title: 'Hospitalization' },
    { items: 'infoMedicalFollowUpInCanadaHomeCareItems', lookup: 'medicalFollowUpInCanadaHomeCare', title: 'Hospitalization' },
    { items: 'infoMedicalFollowUpInCanadaEssentialMedicalAppItems', lookup: 'medicalFollowUpInCanadaEssentialMedicalApp', title: 'Hospitalization' },
    { items: 'infoReturnToYourDestinationItems', lookup: 'returnToYourDestination', title: 'Hospitalization' },
    { items: 'infoOtherHospitalizationItems', lookup: 'otherHospitalization', title: 'Hospitalization' },
    // Essential Medical Equipment, Private Duty Nursing, Fracture Treatment (standalone)
    { items: 'infoEssentialMedicalEquipmentItems', lookup: 'essentialMedicalEquipment', title: 'Essential Medical Equipment' },
    { items: 'infoPrivateDutyNursingItems', lookup: 'privateDutyNursing', title: 'Private Duty Nursing' },
    { items: 'infoFractureTreatmentItems', lookup: 'fractureTreatment', title: 'Doctor\'s Visit' },
    // Unexpected Birth of a Child
    { items: 'infoUnexpectedBirthOfChildItems', lookup: 'unexpectedBirthOfChild', title: 'Unexpected Birth of a Child' },
    // Dental Services
    { items: 'infoDentalAccidentItems', lookup: 'dentalAccident', title: 'Dental Services' },
    { items: 'infoDentalPainOtherItems', lookup: 'dentalPainOther', title: 'Dental Services' },
    // Expenses Related to Death
    { items: 'infoExpensesRelatedToDeathReturnRemainsItems', lookup: 'deathReturnOfRemains', title: 'Expenses Related to Death' },
    { items: 'infoExpensesRelatedToDeathBurialCremationItems', lookup: 'deathBurialCremation', title: 'Expenses Related to Death' },
    { items: 'infoExpensesRelatedToDeathFamilyTransportationItems', lookup: 'deathFamilyTransportation', title: 'Expenses Related to Death' },
    // Professional Services
    { items: 'infoPhysiotherapistItems', lookup: 'physiotherapist', title: 'Professional Services' },
    { items: 'infoChiropractorItems', lookup: 'chiropractor', title: 'Professional Services' },
    { items: 'infoChiropodistItems', lookup: 'chiropodist', title: 'Professional Services' },
    { items: 'infoOsteopathItems', lookup: 'osteopath', title: 'Professional Services' },
    { items: 'infoPodiatristItems', lookup: 'podiatrist', title: 'Professional Services' },
    { items: 'infoAcupuncturistItems', lookup: 'acupuncturist', title: 'Professional Services' },
    { items: 'infoOptometristItems', lookup: 'optometrist', title: 'Professional Services' },
    // Remote Evacuation
    { items: 'infoRemoteEvacuationItems', lookup: 'remoteEvacuation', title: 'Remote Evacuation' },
    // Vision Care and Hearing Aids
    { items: 'infoVisionCareHearingAidsItems', lookup: 'visionCareHearingAids', title: 'Vision Care and Hearing Aids' },
    // Air Travel Delay
    { items: 'infoAirTravelDelayHotelOrRestaurantItems', lookup: 'airTravelDelayHotelOrRestaurant', title: 'Air Travel Delay' },
    { items: 'infoAirTravelDelayAdditionalTransportItems', lookup: 'airTravelDelayAdditionalTransport', title: 'Air Travel Delay' },
    { items: 'infoAirTravelDelayEntertainmentItems', lookup: 'airTravelDelayEntertainment', title: 'Air Travel Delay' },
    { items: 'infoAirTravelDelayEssentialClothingItems', lookup: 'airTravelDelayEssentialClothing', title: 'Air Travel Delay' },
    // Other (unrelated to any benefit listed above)
    { items: 'infoOtherUnrelatedBenefitItems', lookup: 'otherUnrelatedBenefit', title: 'Other' },
  ];

  const allExpenses = expenseConfigs.flatMap((config) => {
    const lookupConfig = lookupKeyToConfig[config.lookup];
    const condition = lookupConfig && lookupConfig.condition ? lookupConfig.condition() : true;
    return mapExpensesByType(data, config.items, config.lookup, condition, config.title);
  });

  return [...allExpenses];
}

function mapToClaimExpensesLevel(data, claimTypes, selectedBenefits) {
  const selected =
    !!selectedBenefits && typeof selectedBenefits.toJS === 'function'
      ? selectedBenefits.toJS()
      : selectedBenefits || [];
  const claimCodeList = expenseLookup.claimCodeList;
  const list = [];
  if (selected.length > 0 && !selected.some((sel) => claimCodeList.includes(sel.claimCode))) {
    return list;
  }

  const expensesSelected = !!data.whatExpensesAreYouClaimingFor && typeof data.whatExpensesAreYouClaimingFor.toJS === 'function'
    ? data.whatExpensesAreYouClaimingFor.toJS()
    : data.whatExpensesAreYouClaimingFor || [];

  if (expensesSelected.length < 1 || claimTypes === undefined) {
    return list;
  }

  const medicalExpenses = mapToExpenses(data);

  const getClaimCodeFromLookup = (lookupKey) => {
    const lookup = expenseLookup[lookupKey];
    return (lookup && lookup.claimCode)
      || (lookup && lookup.associatedClaimCodes && lookup.associatedClaimCodes.length > 0
        ? lookup.associatedClaimCodes[0]
        : null);
  };

  const lookupKeyToConfig = getLookupKeyToConfig(data, expensesSelected);

  const documentSectionsByClaimCode = new Map();

  Object.keys(lookupKeyToConfig).forEach((lookupKey) => {
    const claimCode = getClaimCodeFromLookup(lookupKey);
    const config = lookupKeyToConfig[lookupKey];
    const documentClaimCode = config.documentClaimCodeLookupKey
      ? getClaimCodeFromLookup(config.documentClaimCodeLookupKey)
      : claimCode;
    if (!documentClaimCode) return;
    if (!config.condition || !config.condition()) return;

    const matchingExpenseType = config.expenseTypes.find((expenseType) =>
      expensesSelected.includes(expenseType)
    );
    if (!matchingExpenseType) return;

    const description =
      (config.getDocumentDescription && config.getDocumentDescription()) ||
      (config.getDescription && config.getDescription()) ||
      matchingExpenseType;

    const lookupExpenses = (medicalExpenses || []).filter((expense) => expense.claimTypeCode === claimCode);

    if (!documentSectionsByClaimCode.has(documentClaimCode)) {
      documentSectionsByClaimCode.set(documentClaimCode, {
        description,
        expenses: [],
        lookupKeys: [],
      });
    }
    const entry = documentSectionsByClaimCode.get(documentClaimCode);
    entry.expenses.push(...lookupExpenses);
    entry.lookupKeys.push(lookupKey);
  });

  documentSectionsByClaimCode.forEach((entry, documentClaimCode) => {
    const claimTypeItem =
      claimTypes.find((item) => item.claimCode === documentClaimCode) ||
      entry.lookupKeys
        .map((key) => claimTypes.find((item) => item.claimCode === getClaimCodeFromLookup(key)))
        .find(Boolean);
    if (claimTypeItem) {
      const lookupConfig = lookupKeyToConfig[entry.lookupKeys[0]];
      const benefit = mapClaimExpensesLevelItem(
        claimTypeItem,
        entry.description,
        entry.expenses.map((expense) => ({
          ...expense,
          benefitTitle: lookupConfig.benefitTitle,
          shortDescription: lookupConfig.getDescription ? lookupConfig.getDescription() : expense.shortDescription,
        }))
      );
      benefit.claimCode = documentClaimCode;
      list.push(benefit);
    }
  });

  return list;
}

function mapExpenseItem(item, claimCode) {
  const plainItem = (item && typeof item.toJS === 'function') ? item.toJS() : item;
  if (!plainItem || !plainItem.amountClaimed || !plainItem.currency) {
    return null;
  }
  const selectedClaimForArray = Array.isArray(plainItem.selectedClaimFor)
    ? plainItem.selectedClaimFor
    : [];
  const claimForInsuredIds = selectedClaimForArray.map((claimFor) => claimFor.policyRoleID);
  return {
    shortDescription: `${plainItem.descriptionOfItem}`,
    dateOfExpense: plainItem.dateOfExpenses,
    clientCost: plainItem.amountClaimed,
    currency: plainItem.currency,
    rate: null,
    requestedAmount: null,
    claimTypeCode: claimCode,
    claimForInsuredIds,
    claimForInsureds: selectedClaimForArray,
  };
}

function mapClaimExpensesLevelItem(claimType, description, expenses) {
  return {
    claimCode: claimType.claimCode,
    description,
    claimTypeId: claimType.claimTypeId,
    requiredDocuments: claimType.requiredDocuments,
    parentBenefitCode: claimType.parentBenefitCode,
    order: null,
    expenses: expenses || [],
  };
}

export default {
  mapToParentSection,
  mapToQuestionnaire,
  mapToExpenses,
  mapToClaimExpensesLevel,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/stepTravellerMedicalBenefitsTugoDataMapper.js